export const configApiLinks = {
  getCheckData: 'receipts/shift/status',
  loginUser: 'login/',
  updateProductCount: 'receipts/product/setqty',
  openPaymentSetType: 'receipts/openpaymentsettype',
  makePayment: 'receipts/payment',
  addProduct: 'receipts/scannedCode',
  sendToApprove: 'receipts/process',
  getChecksHistory: 'receipts/history',
  removeProduct: 'receipts/product/delete',
  findProducts: 'products/findByParams',
  productsEditPrice: 'products/editPrice',
  findProductsBarcode: 'products/findByBarcode',
  findAddProductWeightCode: 'receipts/product/findAddByWeightCode',
  addProductById: 'receipts/product/add',
  addCashLink: 'receipts/frcashin',
  removeCashLink: 'receipts/frcashout',
  setDiscountManual: 'receipts/product/discount/setmanual',
  returnReceipt: 'receipts/return',
  cancelReceiptReturn: 'receipts/cancelreturn',
  clearDiscountLoyaltyCard: 'receipts/cleardiscountloyaltycard',
  clearReceiptProducts: 'receipts/clearproducts',
  getCashHistory: 'receipts/cashhistory',
  openShift: 'equipment/fiscregistrar/openshift',
  closeShift: 'equipment/fiscregistrar/zreport',
  xReport: 'equipment/fiscregistrar/xreport',
  getWeightFromScales: 'equipment/scales/getweight',
  printProductLabels: 'print/pricelabel/print',
  frGetData: 'equipment/fiscregistrar/frgetdata',
  frUpdateData: 'equipment/fiscregistrar/frupddata',
  getZReports:'equipment/vchasno/getreports',
  getShiftPrintData:'equipment/vchasno/getshiftprintdata',
  receiptProductExciseAdd: 'receipts/product/esciseadd',
  receiptProductExciseDelete: 'receipts/product/escisedelete',
  receiptProductExciseSet: 'receipts/product/esciseset',
  display2ReceiptData: 'equipment/display2receiptdata',
  printReceiptGetPdf: 'print/receipt/getPdf',
  printXReportGetPdf: 'print/xreport/getPdf',
  printZReportGetPdf: 'print/zreport/getPdf',
  getReceiptWrapInfo: 'receipts/getreceiptwrapinfo',
  getReceiptsOrders: 'receipts/getreceiptsorders',
  selectReceiptOrder: 'receipts/selectreceiptorder',
  getPostponedReceipts: 'receipts/getpostponedreceipts',
  postponeReceipt: 'receipts/postponereceipt',
  selectPostponedReceipt: 'receipts/selectpostponedreceipt',
  getFiscLogs: 'fisclog/list',
};
